import { Action } from "@ngrx/store";

export const UPDATE_GRID_SUCCESS = '[Grid] Update Grid Success';
export const UPDATE_GRID_FAIL = '[Grid] Update Grid Fail';
export const ADD_GRID_SUCCESS = '[Grid] Add Grid Success';
export const ADD_GRID_FAIL = '[Grid] Add Replacement Values Fail';
export const DELETE_GRID_SUCCESS = '[Grid] Delete Grid Success';
export const DELETE_GRID_FAIL = '[Grid] Delete Grid Fail';

export class UpdateGridSuccess implements Action {
  readonly type = UPDATE_GRID_SUCCESS;
  constructor(public payload: any = null) { }
}

export class UpdateGridFail implements Action {
  readonly type = UPDATE_GRID_FAIL;
  constructor(public payload: any = null) { }
}

export class AddGridSuccess implements Action {
  readonly type = ADD_GRID_SUCCESS;
  constructor(public payload: any = null) { }
}

export class AddGridFail implements Action {
  readonly type = ADD_GRID_FAIL;
  constructor(public payload: any = null) { }
}

export class DeleteGridSuccess implements Action {
  readonly type = DELETE_GRID_SUCCESS;
  constructor(public payload: any = null) { }
}

export class DeleteGridFail implements Action {
  readonly type = DELETE_GRID_FAIL;
  constructor(public payload: any = null) { }
}

export type GridActions =
  | UpdateGridSuccess
  | UpdateGridFail
  | DeleteGridSuccess
  | DeleteGridFail
  | AddGridSuccess
  | AddGridFail;